const Flickity = require('flickity')
import { gsap } from 'gsap'

export default class Carousel {
  constructor(el) {
    this.el = el
    this.setVars()
    this.init()
    this.bindings()
  }

  setVars() {
    this.flickity = null
    this.carousel = this.el.querySelector('.main-carousel')
    this.next = this.el.querySelector('[data-next]')
    this.prev = this.el.querySelector('[data-prev]')
    this.isDragging = false
    this.draggingClass = 'is-dragging'
  }

  init() {
    this.prev.classList.add('s-disabled')
    this.carousel.classList.remove('hidden')

    this.flickity = new Flickity(this.carousel, {
      cellAlign: 'left',
      contain: true,
      groupCells: '80%',
      pageDots: false,
      prevNextButtons: false,
      on: {
        ready: () => {
          this.handleReady()
        },
        change(index) {},
      },
    })
    this.flickity.on('dragStart', () => {
      this.el.classList.add(this.draggingClass)
    })

    // Delay removing class so that we can watch for it elsewhere. 100ms is probably more than we need
    this.flickity.on('dragEnd', () => {
      setTimeout(() => {
        this.el.classList.remove(this.draggingClass)
      }, '100')
    })

    if (this.flickity.cells.length < 2) {
      this.disableButton(this.next)
    }
    this.flickity.on('scroll', (progress) => {
      if (progress <= 0) {
        this.disableButton(this.prev)
      } else {
        this.enableButton(this.prev)
      }
      if (progress >= 1) {
        this.disableButton(this.next)
      } else {
        this.enableButton(this.next)
      }
    })
  }

  bindings() {
    this.next.addEventListener('click', this.handleNext)
    this.prev.addEventListener('click', this.handlePrev)
  }

  disableButton(el) {
    el.classList.add('s-disabled')
  }

  enableButton(el) {
    el.classList.remove('s-disabled')
  }

  handleNext = () => {
    this.flickity.next()
  }

  handlePrev = () => {
    this.flickity.previous()
  }

  handleReady = () => {
    gsap.to(this.carousel, {
      opacity: 1,
      duration: 1,
    })
  }
}
